// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const initI18n = async (langKey: string) => {
  const common = await fetch('/labels/default.json').then((res) => res.json());

  await i18n.use(initReactI18next).init({
    resources: {
      [langKey]: {
        translation: common,
      },
    },
    lng: langKey,
    fallbackLng: 'default',
    interpolation: { escapeValue: false },
  });
};

export default i18n;
